import CustomPagination from "components/CustomPagination";
import { Card, Line } from "ktm-ui";
import React from "react";
import { Button, Spinner, Table } from "react-bootstrap";
import Moment from "react-moment";
import moment from "moment";
import { CustomDateRangePicker, toLocalDateParam } from "components/CustomDateRangePicker";
import { CSVLink } from "react-csv";
import toastr from "toastr";

export default class OpsTaxesReimbursements extends React.Component<any, any> {
	state = {
		success: false,
		results: [],
		ONResults: [],
		total: 0,
		currentPage: 1,
		itemsPerPage: 10,
		currentONPage: 1,
		itemsONPerPage: 10,
		fromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		toDate: new Date(),
		showONTaxes: false,
	};

	setCurrentPage = (page: number) => {
		this.setState({ currentPage: page });
	};

	setCurrentONPage = (page: number) => {
		this.setState({ currentONPage: page });
	};

	fetchData = () => {
		fetch(
			"/api/opstransfer/gettaxreimbursements?dateFrom=" +
			toLocalDateParam(this.state.fromDate) +
			"&dateTo=" +
			toLocalDateParam(this.state.toDate)
		)
			.then((response) => response.json())
			.then((data) => {
				this.setState({
					results: data,
				});
			})
			.catch((error) => {
				toastr.error("Failed to fetch data");
			});
	};

	fetchONData = () => {
		if (!this.state.showONTaxes) {
			fetch(
				"/api/opstransfer/getontaxreimbursements?dateFrom=" +
				toLocalDateParam(this.state.fromDate) +
				"&dateTo=" +
				toLocalDateParam(this.state.toDate)
			)
				.then((response) => response.json())
				.then((data) => {
					this.setState({
						ONResults: data,
						showONTaxes: true
					});
				})
				.catch((error) => {
					toastr.error("Failed to fetch ON data");
				});
		}
		else {
			this.setState({ showONTaxes: false });
		}
	}

	setFromDate = (date) => {
		this.setState({
			fromDate: date,
		});
	};

	setToDate = (date) => {
		this.setState({
			toDate: date,
		});
	};

	getTotals = (accounttype) => {
		const filteredResults = this.state.results.filter(x => x.accounttype === accounttype);

		const totalApprovedSum = filteredResults.reduce((sum, item) => sum + item.totalapproved, 0);
		const totalAdminFeeSum = filteredResults.reduce((sum, item) => sum + item.totaladminfee, 0);
		const totalNhcPortion = filteredResults.reduce((sum, item) => sum + item.nhcportion, 0);
		const totalDistroPortion = filteredResults.reduce((sum, item) => sum + item.distroportion, 0);
		const totalGstHst = filteredResults.reduce((sum, item) => sum + item.gst_hst, 0);

		return { totalApprovedSum, totalAdminFeeSum, totalNhcPortion, totalDistroPortion, totalGstHst }
	}

	getONTaxTable = () => {
		const today = new Date().toISOString().slice(0, 10);
		const indexOfLastRecordON = this.state.currentONPage * this.state.itemsONPerPage;
		const indexOfFirstRecordON = indexOfLastRecordON - this.state.itemsONPerPage;
		const currentONRecords = this.state.ONResults.slice(
			indexOfFirstRecordON, indexOfLastRecordON
		);
		const nPagesON = Math.ceil(
			this.state.ONResults.length / this.state.itemsONPerPage
		);

		return (
			<>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						left: "25px",
						margin: "0px",
						fontWeight: 500,
						fontSize: 20,
						padding: 5
					}}
				>
					<div>Ontario Taxes</div>
					<CSVLink
						data={this.state.ONResults}
						filename={`on_taxes_${today}.csv`}
					>
						<Button
							variant="primary"
							className="csv-button export-to-csv"
						>
							<span className="csv-text">Export to CSV</span>
						</Button>
					</CSVLink>
				</div>
				<table className="table">
					<thead>
						<tr>
							<th>Claim No</th>
							<th>Disbursement Date</th>
							<th>Account Type</th>
							<th className="text-end">Total Claim</th>
							<th className="text-end">Total Admin Fee</th>
							<th className="text-end">NHC Portion</th>
							<th className="text-end">Distro Portion</th>
							<th className="text-end">ON HST</th>
							<th className="text-end">ON RST</th>
							<th className="text-end">ON Premium</th>
						</tr>
					</thead>
					<tbody>
						{currentONRecords.map((data, i) => {
							return (
								<tr key={i}>
									<td>{data.claimno}</td>
									<td>{data.formattedDate}</td>
									<td>{data.accounttype}</td>
									<td className="text-end">
										{data.claimtotal.toLocaleString(undefined, {
											style: "currency",
											currency: "USD",
										})}
									</td>
									<td className="text-end">
										{data.totaladminfee.toLocaleString(undefined, {
											style: "currency",
											currency: "USD",
										})}
									</td>
									<td className="text-end">
										{data.nhcportion.toLocaleString(undefined, {
											style: "currency",
											currency: "USD",
										})}
									</td>
									<td className="text-end">
										{data.distroportion.toLocaleString(undefined, {
											style: "currency",
											currency: "USD",
										})}
									</td>
									<td className="text-end">
										{data.on_hst.toLocaleString(undefined, {
											style: "currency",
											currency: "USD",
										})}
									</td>
									<td className="text-end">
										{data.on_rst.toLocaleString(undefined, {
											style: "currency",
											currency: "USD",
										})}
									</td>
									<td className="text-end">
										{data.on_premium.toLocaleString(undefined, {
											style: "currency",
											currency: "USD",
										})}
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>

				<div
					className="pagination-container"
					style={{
						position: "relative",
						right: "10px",
						margin: "0px",
						justifyContent: "end",
					}}
				>
					<div className="pagination-info">
						<span>
							Showing {indexOfFirstRecordON + 1} -{" "}
							{indexOfFirstRecordON + currentONRecords.length} entries out of{" "}
							{this.state.ONResults.length} entries
						</span>
					</div>
					<CustomPagination
						nPages={nPagesON}
						currentPage={this.state.currentONPage}
						setCurrentPage={this.setCurrentONPage}
					/>
				</div>
			</>
		)
	}

	render() {
		const indexOfLastRecord = this.state.currentPage * this.state.itemsPerPage;
		const indexOfFirstRecord = indexOfLastRecord - this.state.itemsPerPage;
		const currentRecords = this.state.results.slice(
			indexOfFirstRecord,
			indexOfLastRecord
		);
		const nPages = Math.ceil(
			this.state.results.length / this.state.itemsPerPage
		);

		var resultsTable = null;
		if (this.state.results.length > 0) {
			resultsTable = (
				<>
					<table className="table">
						<thead>
							<tr>
								<th>Claim No</th>
								<th>Account Type</th>
								<th>Disbursement Date</th>
								<th className="text-end">Total Approved</th>
								<th className="text-end">Total Admin Fee</th>
								<th className="text-end">NHC Portion</th>
								<th className="text-end">Distro Portion</th>
								<th className="text-end">Tax Jurisdiction</th>
								<th className="text-end">GST/HST</th>
							</tr>
						</thead>
						<tbody>
							{currentRecords.map((data, i) => {
								return (
									<tr key={i}>
										<td>{data.claimno}</td>
										<td>{data.accounttype}</td>
										<td>{data.formattedDate}</td>
										<td className="text-end">
											{data.totalapproved.toLocaleString(undefined, {
												style: "currency",
												currency: "USD",
											})}
										</td>
										<td className="text-end">
											{data.totaladminfee.toLocaleString(undefined, {
												style: "currency",
												currency: "USD",
											})}
										</td>
										<td className="text-end">
											{data.nhcportion.toLocaleString(undefined, {
												style: "currency",
												currency: "USD",
											})}
										</td>
										<td className="text-end">
											{data.distroportion.toLocaleString(undefined, {
												style: "currency",
												currency: "USD",
											})}
										</td>
										<td className="text-end">{data.taxjurisdiction}</td>
										<td className="text-end">
											{data.gst_hst.toLocaleString(undefined, {
												style: "currency",
												currency: "USD",
											})}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
					<div
						className="pagination-container"
						style={{
							position: "relative",
							right: "10px",
							margin: "0px",
							justifyContent: "end",
						}}
					>
						<div className="pagination-info">
							<span>
								Showing {indexOfFirstRecord + 1} -{" "}
								{indexOfFirstRecord + currentRecords.length} entries out of{" "}
								{this.state.results.length} entries
							</span>
						</div>
						<CustomPagination
							nPages={nPages}
							currentPage={this.state.currentPage}
							setCurrentPage={this.setCurrentPage}
						/>
					</div>

					<div className="pt-3">
						<table className="table">
							<thead>
								<tr>
									<th>Account Type</th>
									<th className="text-end">Total Approved</th>
									<th className="text-end">Total Admin Fee</th>
									<th className="text-end">Total NHC Portion</th>
									<th className="text-end">Total Distro Portion</th>
									<th className="text-end">Total GST/HST</th>
								</tr>
							</thead>
							<tbody>
								{["HSA", "LSA"].map(type => {
									const totals = this.getTotals(type);

									return (
										<tr>
											<td>{type}</td>
											<td className="text-end">
												{totals.totalApprovedSum.toLocaleString(undefined, {
													style: "currency",
													currency: "USD",
												})}
											</td>
											<td className="text-end">
												{totals.totalAdminFeeSum.toLocaleString(undefined, {
													style: "currency",
													currency: "USD",
												})}
											</td>
											<td className="text-end">
												{totals.totalNhcPortion.toLocaleString(undefined, {
													style: "currency",
													currency: "USD",
												})}
											</td>
											<td className="text-end">
												{totals.totalDistroPortion.toLocaleString(undefined, {
													style: "currency",
													currency: "USD",
												})}
											</td>
											<td className="text-end">
												{totals.totalGstHst.toLocaleString(undefined, {
													style: "currency",
													currency: "USD",
												})}
											</td>
										</tr>
									)
								})}
							</tbody>
						</table>
					</div>

					<button onClick={this.fetchONData} style={{
						fontWeight: "bold",
						textDecoration: "underline",
						cursor: "pointer",
					}}>
						{this.state.showONTaxes ? '<< Show Less' : 'Show More >>'}
					</button>

					{this.state.showONTaxes && this.getONTaxTable()}
				</>
			);
		}

		const today = new Date().toISOString().slice(0, 10);
		const fileName = `opstransfers_${today}.csv`;

		return (
			<>
				<div>
					<div className="mb-2 d-flex flex-wrap gap-2">
						<CustomDateRangePicker
							fromDate={this.state.fromDate}
							toDate={this.state.toDate}
							setFromDate={this.setFromDate}
							setToDate={this.setToDate}
						/>

						<button
							onClick={this.fetchData}
							type="button"
							className="btn btn-primary btn-sm"
						>
							Submit
						</button>
						{this.state.results.length > 0 ? (
							<div>
								<CSVLink
									data={this.state.results}
									filename={fileName}
								>
									<Button
										variant="primary"
										className="csv-button export-to-csv"
									>
										<span className="csv-text">Export to CSV</span>
									</Button>
								</CSVLink>
							</div>
						) : null}
					</div>

					{resultsTable}
				</div>
			</>
		);
	}
}
